export default "__VITE_ASSET__DJd2J2uF__"